import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseurl, imageUrl } from "../../../component/Baseurl";
import logo from "../../../component/img/logo3.jpg";
function HomeAllPackages() {
  const [packages, setPackages] = useState([]);

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await axios.get(`${baseurl}/GetAllPackages`);
        if (response.data && response.data.packages) {
          setPackages(response.data.packages);
        }
      } catch (error) {
        console.error("Error fetching packages:", error);
      }
    };
    fetchPackages();
  }, []);

  return (
    <section>
      <div className="rows pla pad-bot-redu tb-space w-100">
        <div className="pla1 p-home container">
          <div className="spe-title spe-title-1">
            <h2>
              Top <span>Sight Seeing</span> in this month
            </h2>
            <div className="title-line">
              <div className="tl-1"></div>
              <div className="tl-2"></div>
              <div className="tl-3"></div>
            </div>
            <p>
              World's leading tour and travels Booking website, Over 30,000
              packages worldwide. Book travel packages and enjoy your holidays
              with a distinctive experience.
            </p>
          </div>

          <div className="popu-places-home row g-0">
            {packages.map((pkg) => (
              <div key={pkg.id} className="col-md-6 col-sm-6 col-xs-12 place row">
                <div className="col-md-6 col-sm-12 col-xs-12">
                  <img src={pkg.banner_image ? `${imageUrl}packages/${pkg.banner_image}` : logo} alt={pkg.package_name} />
                </div>
                <div className="col-md-6 col-sm-12 col-xs-12">
                  <h3>
                    <span>{pkg.package_name}</span> - {pkg.price} INR
                  </h3>
                  <p>{pkg.package_description}</p>
                  <a href={`/package-detail/${pkg.slug}`} className="link-btn">
                    More Info
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default HomeAllPackages;
